import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header, Loader, Table, Button } from 'semantic-ui-react';
import { getRecentLoginsFromARatedCompanies, RecentLoginItem } from '~/api/admin';
import { format } from 'date-fns';

const RecentLoginsPanel: React.FC = () => {
  const location = useLocation();
  const [data, setData] = useState<RecentLoginItem[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getRecentLoginsFromARatedCompanies();
        setData(result || []);
      } catch (error) {
        console.error('Error fetching recent logins:', error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="card">
        <Header as="h2">Recent Logins (A-Rated Companies)</Header>
        <Loader active inline="centered" />
      </div>
    );
  }

  const formatLoginTime = (isoString: string) => {
    try {
      const date = new Date(isoString);
      return format(date, 'MMM d, yyyy h:mm a');
    } catch {
      return isoString;
    }
  };

  return (
    <div className="card">
      <Header as="h2">Recent Logins (A-Rated Companies)</Header>
      {data?.length ? (
        <Table compact size="small">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>User</Table.HeaderCell>
              <Table.HeaderCell>Company</Table.HeaderCell>
              <Table.HeaderCell>Last Login</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.map((item) => (
              <Table.Row key={item.userId}>
                <Table.Cell>
                  <div>{item.userName}</div>
                  <div style={{ fontSize: '0.85em', color: '#666' }}>{item.userEmail}</div>
                </Table.Cell>
                <Table.Cell>{item.companyName}</Table.Cell>
                <Table.Cell>{formatLoginTime(item.lastLogin)}</Table.Cell>
                <Table.Cell>
                  <Button
                    as="a"
                    secondary
                    size="small"
                    href={
                      '/dashboard' +
                      location.search +
                      (location.search ? '&' : '?') +
                      'spoof=' +
                      encodeURIComponent(item.userEmail)
                    }
                    target="_blank"
                  >
                    Spoof!
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      ) : (
        <p>No recent logins from A-rated companies</p>
      )}
    </div>
  );
};

export default RecentLoginsPanel;
